var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('kst-input',{attrs:{"field":"CategoryID","data":_vm.data,"catalog":_vm.Catalog,"options":_vm.categoryOption}}),_c('kst-input',{attrs:{"field":"Name","data":_vm.data,"catalog":_vm.Catalog}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }